<template>
  <div class="professional">
    <el-collapse v-model="activeNames">
      <el-collapse-item :name='index'>
        <template
          slot="title"
          class="small">
          <div class="tit-wapper-per">
            <div class="discTitle jm-fl">
              <span>专业<span>{{ index+1 }}</span>:(申请编号:)</span><i
                class="el-collapse-item__header__arrow el-icon-arrow-right"
                style="float: left;"/>
              <span/>
            </div>
          </div>
          <el-button
            type="primary"
            size="small"
            class="showing1"
            @click.stop="addNewmajors">添加专业</el-button>
          <el-button
            type="primary"
            size="small"
            class="showing1"
            @click.stop="clear(index)">删除该专业</el-button>
          <el-button
            type="primary"
            size="small"
            class="showing1"
            @click.stop="dialogVisiblepopover = true">复制其他OFFER申请专业信息</el-button>
        </template>
        <div class="schoolInformation">
          <div class="mes-wapper  jm-fl">
            <span><i class="annotation">*</i>申请项目:</span>
            <el-select
              v-model="value"
              placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"/>
            </el-select>
          </div>
          <div class="mes-wapper  jm-fl">
            <el-select
              v-model="value"
              placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"/>
            </el-select>
          </div>
        </div>
        <div class="degreeType">
          <div class="inputWrap">
            <span><i class="annotation">*</i>专业方向:</span>
            <el-input
              v-model="majormes.applyMajor"
              placeholder="请输入内容"/>
          </div>
        </div>
        <div class="inter">
          <div
            class="inputWrap"
            style="width: 95%">
            <span><i class="annotation">*</i>网址:</span>
            <el-input
              v-model="majormes.url"
              placeholder="请输入"/>
          </div>
        </div>
        <el-input
          style="margin: 8px;width: 95%"
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 4}"
          placeholder="主要课程:"
          v-model="majormes.grade"/>
        <div class="timing">
          <div class="mes-wapper  jm-fl">
            <span>开学期:</span>
            <el-date-picker
              v-model="majormes.applyOpen"
              type="month"
              placeholder="选择月"/>
          </div>
          <div class="mes-wapper  jm-fl">
            <span>出愿时间:</span>
            <el-date-picker
              v-model="majormes.applyTuition"
              type="month"
              placeholder="选择月"/>
          </div>
        </div>
        <slot
          name="show"
          v-if="hasUpload"/>
      </el-collapse-item>
    </el-collapse>
    <el-dialog
      title="提示信息"
      :visible.sync="dialogVisiblepopover">
      <jm-popover :pop-title="popTitle"/>
    </el-dialog>
  </div>
</template>
<script>
import popover from '@/components/order/popoverDuplicate';

export default {
  props: {
    showWhich: {
      type: String,
    },
    hasUpload: {
      type: Boolean,
    },
    majormes: {
      type: Object,
    },
    majors: {
      type: Array,
    },
    index: {
      type: Number,
    },
  },
  data() {
    return {
      dialogVisiblepopover: false,
      activeNames: 0,
      input: '',
      popTitle: '申请编号',
      value: '',
      value4: '',
      options: [{
        value: '选项1',
        label: '黄金糕'
      }, {
        value: '选项2',
        label: '双皮奶'
      }, {
        value: '选项3',
        label: '蚵仔煎'
      }, {
        value: '选项4',
        label: '龙须面'
      }, {
        value: '选项5',
        label: '北京烤鸭'
      }],
      textarea3: '',
      checked: true,
    };
  },
  methods: {
    addNewmajors() {
      this.majors.push({
        applycost: '',
        applycode: '',
        applyMajor: '',
        applyType: '',
        url: '',
        grade: '',
        entry: '',
        applyIelts: '',
        applymin: '',
        applySpecial: '',
        applyToefl: '',
        applyToeflL: '',
        applyToeflR: '',
        applyToeflW: '',
        applyToeflS: '',
        applyTuition: '',
        applyOpen: '',
        applyPeriod: '', // 明天绑上 先把循环对象传入到子组件中
      });
    },
    clear(index) {
      this.majors.splice(index, 1);
    },
  },
  components: {
    'jm-popover': popover,
  },
};
</script>
<style>
  .timing>div:nth-of-type(1){
    margin-right: 50px;
  }
  .timing:after{
    display: block;
    content: '';
    clear: both;
    opacity: 0;
    visibility: hidden;
  }
</style>
